"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const InversifySugar_1 = __importDefault(require("./InversifySugar"));
const bindProviderToContainer_1 = require("./binding/bindProviderToContainer");
const bindExportedProviderRefToContainer_1 = __importDefault(require("./binding/bindExportedProviderRefToContainer"));
/**
 * @description Wrapper for inversify container to handle provided and imported concerns
 */
class ModuleContainer {
    constructor() {
        this.container = InversifySugar_1.default.globalContainer.createChild();
    }
    isProvided(serviceIdentifier) {
        return this.container.isBoundTagged(serviceIdentifier, constants_1.PROVIDED_TAG, true);
    }
    isImported(serviceIdentifier) {
        return this.container.isBoundTagged(serviceIdentifier, constants_1.IMPORTED_TAG, true);
    }
    bindProvider(provider) {
        (0, bindProviderToContainer_1.bindProviderToContainer)(provider, this.container);
    }
    bindExportedProviderRef(exportedProviderRef) {
        (0, bindExportedProviderRefToContainer_1.default)(exportedProviderRef, this.container);
    }
    getProvided(serviceIdentifier) {
        return this.container.getTagged(serviceIdentifier, constants_1.PROVIDED_TAG, true);
    }
    getAllProvided(serviceIdentifier) {
        return this.container.getAllTagged(serviceIdentifier, constants_1.PROVIDED_TAG, true);
    }
    getImported(serviceIdentifier) {
        return this.container.getTagged(serviceIdentifier, constants_1.IMPORTED_TAG, true);
    }
    getAllImported(serviceIdentifier) {
        return this.container.getAllTagged(serviceIdentifier, constants_1.IMPORTED_TAG, true);
    }
    unbindAllAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.container.unbindAllAsync();
        });
    }
}
exports.default = ModuleContainer;
